module.exports = __webpack_public_path__ + "static/media/lt.fac8e7df.svg";